import { bindActionCreators } from 'redux';
import * as checkoutActions from '../../stateManagement/engine/actions/CheckoutActions';
import {
  displayModal,
  setAssociateDishPaymentIndex,
  clearAssociateDishPaymentIndex,
  hideModal,
} from '../../stateManagement/engine/actions/SessionActions';
import { connect } from 'react-redux';
import Checkout from './Checkout';
import { derivedPpdData } from '../../stateManagement/engine/selectors/derivedPpdData';
import {
  getAllowedPaymentMethods,
  isOrganizationOfflineCreditCard,
  isSplitPaymentAllowed,
} from '../../utils/CheckoutUtils';
import _ from 'lodash';

function mapStateToProps(state) {
  const { payments } = state.checkout;

  return {
    acceptsTip: state.session.acceptsTip,
    paymentsValue: payments,
    placeOrderResult: state.checkout.placeOrderResult,
    paymentTypes: getAllowedPaymentMethods({ organization: state.session.organization, payments }),
    paymentMethods: state.cashier.paymentMethods,
    paymentMetadata: state.cashier.paymentMetadata,
    allowSplitPayments: isSplitPaymentAllowed({ organization: state.session.organization, payments }),
    orderItems: state.order.orderItems,
    payments,
    itemsHash: state.session.itemsHash,
    currency: state.session.organization.currency,
    locale: state.session.organization.locale,
    paymentAssociations: state.order.paymentAssociations,
    checkoutType: state.checkout.checkoutType,
    derivedPpdData: derivedPpdData(state),
    offlinePayments: isOrganizationOfflineCreditCard(state.session.organization),
    networks: _.get(state.session.organization, 'creditcardsInfo.networks', []),
    collectionMethod: _.get(state, 'session.organization.creditcardsInfo.collectionMethod'),
    isWaitingForResponseFromServer: state.checkout.isWaitingForResponseFromServer,
    hasPendingPayment: state.checkout.hasPendingPayment,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    ...bindActionCreators(
      {
        removePayment: checkoutActions.removePayment,
        addPayment: checkoutActions.addPayment,
        selectPaymentType: checkoutActions.selectPaymentType,
        updatePayment: checkoutActions.updatePayment,
        backToOrder: checkoutActions.backToOrder,
        placeOrder: checkoutActions.placeOrder,
        setCheckoutType: checkoutActions.setCheckoutType,
        setAssociateDishPaymentIndex,
        clearAssociateDishPaymentIndex,
        displayModal,
        hideModal,
        selectSinglePaymentMethod: checkoutActions.selectSinglePaymentMethod,
        addCashierPayment: checkoutActions.addCashierPayment,
        setPendingPayment: checkoutActions.setPendingPayment,
      },
      dispatch,
    ),
    ...ownProps,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
